import React from 'react';
import ls from 'local-storage';
import { useHistory, useParams } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import API from "../../Services/BaseService";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import ManageAccountLinks from "../../Component/ManageAccountLinks/ManageAccountLinks";
import PhoneInput from 'react-phone-number-input/input';
import appstore from '../../assets/img/appstore.png';
import Loading from '../../Component/Loading/Loading';
import googleplay from '../../assets/img/googleplay.png';
import adduser from '../../assets/img/adduser.jpg';
import StateAndCity from '../../Component/StateAndCity/StateAndCity'
import StateAndCitySearch from '../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../FallBackUI/PageNotFound';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';

const EditDealerInformation = (props) => {
    const history = useHistory();
    const { id } = props.location.state || {};
    console.log("id", id)
    // const { id } = useParams();
    // const sellerDetails = ls.get('sellerDetails');
    const [accountObjc, setAccountObj] = useState("");
    // const [firstName, setFirstname] = useState("");
    // const [lastName, setLastname] = useState("");
    // const [primaryPhone, setPrimaryphone] = useState("");
    // const [mobilePhone, setMobilephone] = useState("");
    const [dealerName, setDealerName] = useState("");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [zipCode, setZipcode] = useState("");

    const [cityId, setCityId] = useState("");
    const [stateId, setStateId] = useState("");
    const [zipCodeId, setZipcodeId] = useState("");

    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);

    const [idStatename, setIdStatename] = useState(null);
    const [idCityname, setIdCityname] = useState(null);
    const [idZipcodename, setidZipcodename] = useState(null);
    const [stateCityFlag, setStateCityFlag] = useState("");

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }
    // const sellerDetails = useSelector(state => state.LoginReducer.payload);
    // console.log("======successData================",successData)

    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("")
    // const [firstNameError, setFirstNameError] = useState("")
    // const [lastNameError, setLastNameError] = useState("")
    // const [primaryPhoneError, setPrimaryPhoneError] = useState("")
    // const [mobilePhoneError, setMobilePhoneError] = useState("")
    const [addressError, setAddressError] = useState("")
    const [stateAndCityError, setStateAndCityError] = useState("")
    const [doc, setDoc] = useState("");
    const [type, setType] = useState("");
    const sellerDetails = useSelector(state => state.LoginReducer.payload);

    const backUrl = ls.get("backredirection");
    console.log("check the back direction", backUrl.slice(0, -1));
    const back = backUrl[(backUrl.length) - 1];
    console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

    const billofsale = ls.get("BillofSaleId")
    console.log("check the bill of sale value", billofsale);
    const CarId = ls.get("BillOfSaleCarId")

    const [confirmationFlag, setConfirmationFlag] = useState(false);

    const [changesArray, setChangesArray] = useState([]);
    const [changesFlag, setChangesFlag] = useState("no");

    const handleAddressChange = (e) => {
        setChangesFlag("yes")
        const newValue = e.target.value;
        const oldvalue = accountObjc.address;
        setAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'address' };
            setChangesArray([...changesArray, change]);
        }
    }

    console.log("==sellerDetails==", sellerDetails)
    const getStateName = (stateData, flag, type) => {
        setState(stateData)
        setChangesFlag("yes")

        setStateCityFlag(flag)
        const oldvalue = accountObjc.state_name;

        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: stateData, name: type };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: stateData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getCityName = (cityData, flag, type) => {
        setCity(cityData)
        setChangesFlag("yes")

        const oldvalue = accountObjc.city_name;

        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = {
                    ...updatedChangesArray[existingChangeIndex],
                    newvalue: cityData,
                };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: cityData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getZipCodeId = (zipData, flag, type) => {
        setZipcode(zipData)
        setChangesFlag("yes")

        const oldvalue = accountObjc.zipcode;

        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
            const updatedFlag = flag || 'dropdown';
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { ...updatedChangesArray[existingChangeIndex], newvalue: zipData, flag: updatedFlag };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldvalue, newvalue: zipData, name: type, flag: updatedFlag };
                return [...prevChangesArray, change];
            }
        });
    }


    const getError = (data, flag) => {
        console.log("reg flag", data, flag);
        setErrors(data)
        setErrorFlag(flag)
    }

    // const getStateName = (stateData, flag) => {
    //     setIdStatename(stateData)
    //     setStateCityFlag(flag)

    // }

    // const getCityName = (cityData) => {
    //     setIdCityname(cityData)

    // }

    // const getZipCodeId = (zipData) => {
    //     setidZipcodename(zipData)
    // }

    //  useEffect(() => {
    //         setIdStatename(idStatename)
    //         setIdCityname(idCityname)
    //         setidZipcodename(idZipcodename)
    //     }, []);
    const dealerEdit = () => {
        let request = {
            seller_dealer_id: sellerDetails.seller_dealer_id,
            seller_id: sellerDetails.seller_id,
            seller_token: sellerDetails.seller_token
        };
        const state = API.post('seller_dealer_profile/condition', request);
        state.then(res => {
            console.log("res=======>", res.data.data)

            if (res.data.success === true) {
                // setFirstname(res.data.data[0].first_name);
                // setLastname(res.data.data[0].last_name);
                // setPrimaryphone(res.data.data[0].phone_no);
                // setMobilephone(res.data.data[0].mobile_no);
                setAddress(res.data.data[0]?.address);
                setState(res.data.data[0]?.state_name);
                setCity(res.data.data[0]?.city_name);
                setZipcode(res.data.data[0]?.zipcode);
                setDealerName(res.data.data[0]?.dealer_name)

                setAccountObj(res.data.data[0])
                // reset(res.data.data[0]);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    //   setLoading(false);

                }
            });
    }

    function formatMobileNO(value) {
        var x = value.replace(/\D/g, '').match(/(\d{1})(\d{3})(\d{3})(\d{4})/);

        console.log("value of x", x);
        value = '+' + x[1] + '(' + x[2] + ')' + x[3] + '-' + x[4];
        console.log("mobileno", value);
        return value;
    }

    const updateDealerInfo = (event) => {
        // setOpenLoader(true);
        event.preventDefault();

        // setFirstNameError("")
        // setLastNameError("")
        // setPrimaryPhoneError("")
        // setMobilePhoneError("")
        setAddressError("")
        setStateAndCityError("")

        // if(!firstName){
        //     setFirstNameError("First Name is required")
        //     return;
        // }
        // else if(firstName.length>50){
        //     setFirstNameError("First Name must not exceed 50 characters")
        //     return;
        // }
        // if(!lastName){
        //     setLastNameError("Last Name is required")
        //     return;
        // }
        // else if(lastName.length>50){
        //     setLastNameError("Last Name must not exceed 50 characters")
        //     return;
        // }
        // if(!primaryPhone){
        //     setPrimaryPhoneError("Primary Phone is required")
        //     return;
        // }
        // else if(primaryPhone.length<12 ){
        //     setPrimaryPhoneError("Primary Phone must have 10 digits")
        //     return;
        // }
        // if(!mobilePhone){
        //     setMobilePhoneError("Mobile Phone is required")
        //     return;
        // }
        // else if(mobilePhone.length<12){
        //     setMobilePhoneError("Mobile Phone must have 10 digits")
        //     return;
        // }
        if (!address) {
            setAddressError("Address is required")
            return;
        }
        else if (address.length > 150) {
            setAddressError("Address must not exceed 150 characters")
            return;
        }
        // if(!state){
        //     setStateAndCityError("1")
        //     return
        // }
        // if(!city){
        //     setStateAndCityError("1")
        //     return
        // }
        // if(!zipCode){
        //     setStateAndCityError("1")
        //     return
        // }
        if (!(typeof state === 'string' ? accountObjc.state_id : state)) {
            setStateAndCityError("1")
            return;
        }
        if (!(typeof city === 'string' ? accountObjc.city_id : city)) {
            setStateAndCityError("2")
            return;
        }
        if (!(zipCode === accountObjc.zipcode ? accountObjc.zipcode_id : zipCode)) {
            setStateAndCityError("3")
            return;
        }

        let request = {
            seller_dealer_id: id,
            // first_name: firstName,
            // last_name: lastName,
            // phone_no: formatMobileNO(primaryPhone),
            // mobile_no: formatMobileNO(mobilePhone),
            address: address,
            seller_id: sellerDetails.seller_id,
            seller_token: sellerDetails.seller_token,
            // city_id: city,
            // state_id: state,
            // zipcode_id: zipCode,
            city_id: stateCityFlag === "" ? typeof city === 'string' ? accountObjc.city_id : city : "",
            state_id: stateCityFlag === "" ? typeof state === 'string' ? accountObjc.state_id : state : "",
            zipcode_id: stateCityFlag === "" ? zipCode === accountObjc.zipcode ? accountObjc.zipcode_id : zipCode : "",
            city_name: stateCityFlag !== "" ? city : "",
            state_name: stateCityFlag !== "" ? state : "",
            zipcode: stateCityFlag !== "" ? zipCode : "",
            historylist: changesArray,
            valuechanges: changesFlag,
            active: 1,
            image: doc === "" ? doc : doc.length > 0 ? doc : [doc],
            updatedBy: sellerDetails.seller_id
        };
        console.log("dealer request==----==", request)

        // return
        if (type == "") {
            API
                .post('edit_seller/update', request)
                .then((response) => {
                    setConfirmationFlag(false)
                    if (response.data.success) {
                        const { data } = response;
                        console.log("response", response)
                        // ls.set('sellerDetails', response.data.data[0]);
                        // history.push("/success");
                        togglePopup()
                        setPopupTitle("Edit Dealer Information");
                        setPopupMsg(" Edit Dealer Information is successfully Updated");
                        setPopupType("success");
                        setPopupActionType("redirect");
                        setPopupActionValue("ok");
                        setPopupActionPath("/manageaccount")
                        ls.set("BillofSaleId", billofsale);
                        ls.set("BillOfSaleCarId", CarId)
                        ls.set("backredirection", backUrl.slice(0, -1))
                    } else {
                        togglePopup()
                        setPopupTitle("Edit Dealer Information");
                        // setPopupMsg("Edit Dealer Information is not update, Please try Again");
                        setPopupMsg(response.data.error.err);
                        setPopupType("error");
                        setPopupActionType("close");
                        setPopupActionValue("close");
                    }
                }, (error) => {
                    // setOpenLoader(false);
                    // console.log(error);
                    togglePopup()
                    setPopupTitle("Error");
                    setPopupMsg("Something went wrong, Please try Again");
                    setPopupType("error");
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }).catch(function (error) {
                    if (error.response) {
                        setErrors(error.response.data.error)
                        setErrorFlag(true)
                    }
                });
        }
        else {
            console.log("Upload only Image Format");
        }
    }
    const getFiles = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        setType("");

        if (
            file.type === "image/jpeg" ||
            file.type === "image/jpg" ||
            file.type === "image/png"
        ) {
            const reader = new FileReader();

            reader.onload = () => {
                setDoc({
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    base64: reader.result // Data URL
                });
            };

            reader.readAsDataURL(file);
        } else {
            setType("0");
        }
    };
    // useEffect(() => {
    //   dealerEdit();

    // }, []);
    useEffect(() => {
        console.log("use effect calling");
        let request = {
            seller_dealer_id: sellerDetails.seller_dealer_id,
            seller_id: sellerDetails.seller_id,
            seller_token: sellerDetails.seller_token
        };
        const state = API.post('seller_dealer_profile/condition', request);
        state.then(res => {
            console.log("res=======>", res.data.data)
            // setFirstname(res.data.data[0].first_name);
            // setLastname(res.data.data[0].last_name);
            // setPrimaryphone(res.data.data[0].phone_no);
            // setMobilephone(res.data.data[0].mobile_no);
            if (res.data.success === true) {
                setCity(res.data.data[0]?.city_name);

                setAddress(res.data.data[0]?.address);
                setState(res.data.data[0]?.state_name);
                setZipcode(res.data.data[0]?.zipcode);
                setDealerName(res.data.data[0]?.dealer_name)

                setAccountObj(res.data.data[0])
                // reset(res.data.data[0]);
                setLoading(false);

            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);

                }
            });
    }, []);
    // function handleOnChange(value) {
    //     setPrimaryphone(value);
    //  }
    //  function handleOnChanges(value) {
    //     setMobilephone(value);
    //  }

    const handleBackButton = () => {

        history.push({
            pathname: back,
            state: { BillofSale: billofsale, CarId: CarId },
        });
        ls.set("backredirection", backUrl.slice(0, -1))

    }

    const confirmationPopup = () => {

        setConfirmationFlag(!confirmationFlag)

    }
    const customButtonStyle = {
        backgroundColor: "RGB(189,6,44)",
        color: "white",
        height: '40px'
    };


    return (
        <div>

            {loading ? <Loading /> :
                <main id="main" className="inner-page">

                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <div id="addaddress" className="addaddress_block">
                            <div className="container-fluid inner-page-space">
                                <div class="common-heading">
                                    <div className="row">
                                        <div className="col-lg-4">
                                        </div>
                                        <div className="col-lg-4">
                                            <div class="title">
                                                <p class="inner-title">Edit Dealer Information</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                        </div>
                                    </div>
                                </div>
                                <div className="addaddressblock col-lg-12">
                                    <div className="row content">
                                        <div className="col-lg-4 col-md-12 col-sm-12 mgaccountleftblock">
                                            <ManageAccountLinks />
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12 flooraddform">
                                            <div className="adduserpage-inner">
                                                <div className="col-lg-12">
                                                    <form className="registrationform"  >
                                                        <div className="row">
                                                            <div class="common-heading">
                                                                <div className="row">
                                                                    <div className="col-lg-2">
                                                                        <div class="back-btn">
                                                                            <button className="back-btn-paymentform backBtn" onClick={() => handleBackButton()}><i className="icofont-arrow-left"></i> Back</button>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-8">
                                                                        <div class="title">
                                                                            <p class="inner-title"> Edit Dealer Information</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 form-group my-profile-img">
                                                                <div className="user-upload-btn-wrapper">
                                                                    {doc === "" ? (
                                                                        <img alt="" src={accountObjc?.image || adduser} />
                                                                    ) : (
                                                                        <img alt="" src={doc.base64} />
                                                                    )}

                                                                    <span className="proCamera"></span>

                                                                    {type === "0" && (
                                                                        <div className="form-input-error">
                                                                            Upload only Image Format
                                                                        </div>
                                                                    )}

                                                                    <input
                                                                        type="file"
                                                                        accept="image/png,image/jpeg,image/jpg"
                                                                        onChange={getFiles}
                                                                        style={{ display: "none" }}
                                                                        id="profile-upload"
                                                                    />

                                                                    <label htmlFor="profile-upload" className="upload-overlay"></label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 form-group">
                                                                <div className="tbox">
                                                                    <input type="text" defaultValue={accountObjc?.dealer_name} className="form-control textbox" placeholder="" required disabled onChange={(e) => setDealerName(e.target.value)} />
                                                                    <label htmlFor="first_name" className={dealerName != "" ? "input-has-value" : ""}>Dealer Name</label>
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12 form-group">
                                                                <div className="tbox">
                                                                    <input type="text" defaultValue={accountObjc?.address} className="form-control textbox" placeholder="" onChange={handleAddressChange} /* onChange={(e) => setAddress(e.target.value)} */ /* onBlur={(e) => setAddress(e.target.value)} */ />
                                                                    <label htmlFor="address" className={address != "" ? "input-has-value required" : "required"}>Address</label>
                                                                    <p className="form-input-error" >{addressError}</p>

                                                                </div>
                                                            </div>

                                                            {/* <StateAndCitySearch
                                                        setStateValue={getStateName}
                                                        setCityValue={getCityName}
                                                        setZipcodeValue={getZipCodeId}
                                                        stateCityValidation={stateAndCityError}/> */}
                                                            <StateAndCitySearch
                                                                // setStateValue={getStateName}
                                                                // setCityValue={getCityName}
                                                                // setZipcodeValue={getZipCodeId}
                                                                // setNewError={getError}
                                                                setStateValue={(stateData, flag) => getStateName(stateData, flag, 'state')}
                                                                setCityValue={(cityData, flag) => getCityName(cityData, flag, 'city')}
                                                                setZipcodeValue={(zipData, flag) => getZipCodeId(zipData, flag, 'zipcode')}
                                                                setNewError={getError}
                                                                isEdit={true}
                                                                defaultStateValue={state}
                                                                defaultCityValue={city}
                                                                defaultZipcodeValue={zipCode}
                                                                stateCityValidation={stateAndCityError}
                                                                setRequired="true"

                                                            />
                                                            {/* <p className="form-input-error3"> {stateAndCityError} </p> */}
                                                            {/* <div class="col-sm-12 form-group">
                                <input type="text" defaultValue={accountObjc.city_name} class="form-control" placeholder="City" required onChange={(e) => setCity(e.target.value)} />
                            </div>
                            <div class="col-sm-12 form-group">
                            <div className="tbox">
                                <input type="text" defaultValue={accountObjc.state_name} class="textbox" placeholder="State" required onChange={(e) => setState(e.target.value)} />
                                <label htmlFor="state" className={state != "" ? "input-has-value" : ""}>State</label>
                            </div>
                            </div>
                            <div class="col-sm-12 form-group">
                                <input type="number" defaultValue={accountObjc.zipcode_id} class="form-control" placeholder="Zip code" required onChange={(e) => setZipcode(e.target.value)} />
                            </div> */}


                                                            <div className="col-lg-12 loginBtn">
                                                                <Button className="cta-btn btn-smlprimary" style={customButtonStyle} onClick={() => setConfirmationFlag(true)}>Update</Button>
                                                            </div>
                                                        </div>
                                                    </form>

                                                </div>  </div></div></div></div></div></div>}


                    {confirmationFlag &&

                        < >
                            <Modal show={true} onHide={confirmationPopup} centered>
                                <Modal.Header className="Terms-login">
                                    <h2>Edit confirmation</h2>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="CommonModalbody">
                                        <p>Are you sure,If you want to Edit Dealer Information please confirm</p>
                                    </div>

                                    <div className="col-md-12 btns confirmation ">
                                        <button className="cta-btns" onClick={confirmationPopup} >CANCEL</button>
                                        <button className="cta-btns" onClick={updateDealerInfo} >OK</button>
                                    </div>

                                </Modal.Body>
                            </Modal>
                        </>
                    }


                    {isOpen &&
                        <CommonPopup
                            handleClose={togglePopup}
                            popupTitle={popupTitle}
                            popupMsg={popupMsg}
                            popupType={popupType}
                            popupActionType={popupActionType}
                            popupActionValue={popupActionValue}
                            popupActionPath={popupActionPath}
                        />}
                </main>

            }

            <section id="playstoreBlock" className="playstoreBlock">
                <div className="container">
                    <div className="row content">
                        <div className="col-lg-12">
                            <img src={appstore} />
                            <img src={googleplay} />
                        </div>
                    </div>
                </div>
            </section>
        </div>


    );
};

export default EditDealerInformation;